<template>
  <v-data-table
    :headers="headers"
    :items="items"
    :single-expand="singleExpand1"
    :expanded.sync="expanded1"
    hide-default-footer
    :item-key="headers[0].value"
    show-expand
  >
    <template v-slot:top>
      <v-toolbar flat>
        <v-toolbar-title>{{ items[0].title }}</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn v-if="showButton" fab small class="btn-expand" color="primary" @click="expandedAll(items)">
          <v-icon v-if="!showItems" dark>fas fa-angle-down</v-icon>
          <v-icon v-if="showItems" dark>fas fa-angle-up</v-icon>
        </v-btn>
      </v-toolbar>
    </template>
    <template v-slot:expanded-item="{ headers, item }">
      <td :colspan="headers.length" class="pa-6" v-if="hasChildren(item)">
        <i4proTableDetailRecursive :items="item.children" :headers="item.children[0].header" />
      </td>
    </template>
    <template v-slot:item.data-table-expand="{ item, expand, isExpanded }">
      <v-icon v-if="!isExpanded && hasChildren(item)" @click="expand(!isExpanded)">mdi-chevron-down</v-icon>
      <v-icon v-if="isExpanded && hasChildren(item)" @click="expand(!isExpanded)">mdi-chevron-up</v-icon>
    </template>
  </v-data-table>
</template>
<script>
export default {
  components: {
    i4proTableDetailRecursive: () => import('@/components/tables/i4pro-table-detail-recursive')
  },

  props: {
    headers: { type: Array, default: [], required: true },
    items: { type: Array, default: [], required: true }
  },

  data() {
    return {
      expanded1: [],
      singleExpand1: false,
      showButton: true,
      showItems: false
    };
  },

  created() {
    if (this.items[0].children == undefined) {
      this.showButton = false;
    }
  },

  methods: {
    hasChildren(item) {
      return item.children && item.children.length;
    },

    expandedAll(items) {
      if (this.showItems) {
        this.showItems = false;
        this.expanded1 = [];
      } else {
        this.showItems = true;
        for (let item in items) {
          this.expanded1.push(items[item]);
        }
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.btn-expand {
  max-width: 30px;
  height: 30px;

  .fa-angle-up {
    font-size: 20px !important;
  }
  .fa-angle-down {
    font-size: 19px !important;
  }
}
</style>
